var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginationRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5469_10354)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6855 20.3022C11.3749 19.9915 11.3749 19.4879 11.6855 19.1772L16.6382 14.2246L11.6855 9.27187C11.3749 8.96123 11.3749 8.45757 11.6855 8.14693C11.9962 7.83628 12.4998 7.83628 12.8105 8.14693L18.3256 13.6621C18.6363 13.9727 18.6363 14.4764 18.3256 14.787L12.8105 20.3022C12.4998 20.6128 11.9962 20.6128 11.6855 20.3022Z",
    fill: "#3E3E4E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5469_10354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.0117188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationRightArrow);
export default __webpack_public_path__ + "static/media/pagination-right-arrow.ca503ab58aba0a8c5bccc5246f728a43.svg";
export { ForwardRef as ReactComponent };